<template>
    <input
      :type="type"
      :name="name"
      :value="localValue"
      @input="onInput"
      :placeholder="placeholder"
      :list="list || null"
      :class="['input-wide', { 'is-invalid': error }]"
    />
  </template>
  
  <script>
  export default {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: [String, Number],
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      // id of a <datalist> to suggest values from. Left empty the attribute is
      // dropped entirely -- list="" points the input at nothing and kills the
      // browser's own suggestion dropdown.
      list: {
        type: String,
        default: ''
      },
      // Marks the field as failing required-field validation. Bound on the
      // <input> itself rather than left to attribute fallthrough, so the
      // highlight does not depend on this component's root staying the input.
      error: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        localValue: this.value
      };
    },
    watch: {
      value(newVal) {
        this.localValue = newVal;
      }
    },
    methods: {
      onInput(event) {
        this.localValue = event.target.value;
        this.$emit('update:value', event.target.value);
      }
    }
  };
  </script>
  
  <style scoped>
  .input-wide {
    width: 100%;
  }
  </style>
  